import NextHead from 'next/head';

export function Head({
  applicationName,
  buildNumber = '',
  children,
}: React.PropsWithChildren<{
  applicationName: string;
  buildNumber?: string;
}>) {
  return (
    <NextHead>
      <link rel="dns-prefetch" href="//nodes3cdn.hotpads.com" />
      <link rel="dns-prefetch" href="//www.google.com" />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
      <link rel="dns-prefetch" href="//www.facebook.com" />
      <link rel="dns-prefetch" href="//connect.facebook.net" />
      <link rel="dns-prefetch" href="//bat.bing.com" />
      <link rel="dns-prefetch" href="//www.googleadservices.com" />
      <link rel="dns-prefetch" href="//stats.g.doubleclick.net" />
      <link rel="dns-prefetch" href="//adservice.google.com" />
      <link rel="dns-prefetch" href="//googleads.g.doubleclick.net" />
      <link rel="dns-prefetch" href="//pi.pardot.com" />
      <link rel="dns-prefetch" href="//www.googletagmanager.com" />
      <link rel="preconnect" href="https://www.googletagmanager.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://nodes3cdn.hotpads.com" crossOrigin="anonymous" />

      <meta name="rp-application-name" content={applicationName} />
      <meta name="BUILD_NUMBER" content={buildNumber} />
      <meta content="width=device-width, initial-scale=1.0, maximum-scale=5.0, minimal-ui" name="viewport" />
      <meta charSet="UTF-8" />
      <meta content="IE=Edge" httpEquiv="X-UA-Compatible" />
      <meta content="yes" name="apple-mobile-web-app-capable" />
      <meta content="yes" name="mobile-web-app-capable" />
      <meta name="robots" content="noindex, nofollow" />

      {children}
    </NextHead>
  );
}
